import React from 'react';
import { Typography } from '@mui/material';
import { formatCurrency } from '../../utils/invoiceStatus';

interface CurrencyDisplayProps {
  amount: number;
  currency?: string;
}

const CurrencyDisplay: React.FC<CurrencyDisplayProps> = ({
  amount,
  currency = 'AUD',
}) => {
  const isNegative = amount < 0;

  return (
    <Typography
      component="span"
      sx={{
        fontFamily: '"Roboto Mono", "Courier New", monospace',
        color: isNegative ? 'error.main' : 'text.primary',
        fontWeight: 500,
      }}
    >
      {formatCurrency(amount, currency)}
    </Typography>
  );
};

export default CurrencyDisplay;
